import React, { useState, useEffect } from "react";
import * as Icon from "react-feather";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { backendApi } from "../../api/apiService";
import {
    FaCamera,
} from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
function OfficeDetails({ candidate }) {
    const [offerLetterDetails, setofferLetterDetails] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            try {
                const postData = {
                    "functionName": "timeLinehistory",
                       "candidate_id":candidate.id
                  }
                const result = await backendApi(postData);
                console.log(result, "result.logo_url");

                if (result.success === "1") {
                    setofferLetterDetails(result.dataSet);
                }
            } catch (error) {
                console.error("Error fetching site data:", error);
            }
        };
        fetchData();
    }, []);
    const formatDateTime = (dateTimeString) => {
        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        };
        const formattedDateTime = new Date(dateTimeString).toLocaleDateString('en-IN', options);
        return formattedDateTime;
      };
      const handleDownload = (data) => {
        window.open(data.attachments);
      }
      
    return (
        <div className="cardDeatils">
            <ToastContainer
                enableMultiContainer
                containerId={"P"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="cardHeader">Office Details</div>
            <div className="cardData">
                {/* <div className="row xilliFirst">
                        <div className="col-md-12">
                            <div className="p-3" >
                                <div className="col-md-12 p-0 position-relative"> */}
                                {/* {offerLetterDetails */}
                                 {/* <p className="mx-0 mb-1 lead-name"> */}
                                 {offerLetterDetails.map((data, index) => (
                             
                                    <div className="row px-3">
                                       <div className="col-md-1 offerletterdownload">
                                            <FiDownload  onClick={() => handleDownload(data)}/>
                                            <span className="offer-letter-date">
                                               {formatDateTime(data.created_by)}
                                            </span>
                                       </div>
                                    </div>
                          ))} 
                               {/* </p> */}
                                {/* </div>
                                </div>
                                </div>
                </div> */}
            </div>
        </div>
    );
}
export default OfficeDetails;
